
import Vue from "vue";
import { NewCompanyUsersApiFunc, setAccessToken } from "@/api";
import { CompanyUser } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import CompanyUserEditor from "./components/CompanyUserEditor.vue";

export default Vue.extend({
  name: "CompanyUserCreateScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    CompanyUserEditor,
  },

  props: {},

  computed: {},

  methods: {
    async createCompanyUser(companyUser: CompanyUser): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewCompanyUsersApiFunc().createCompanyUser(
        companyId,
        companyUser
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.createCompanyUser(companyUser);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-users",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
